var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Music",
    clipPath: "url(#clip0_10049_8093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.36296 11.0998C3.16296 11.0998 3 10.9369 3 10.7369V5.18132C3 4.98132 3.16296 4.81836 3.36296 4.81836C3.56296 4.81836 3.72593 4.98132 3.72593 5.18132V10.7369C3.72593 10.9369 3.56296 11.0998 3.36296 11.0998Z",
    fill: "#CFD67B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.56291 13.7579C5.36291 13.7579 5.19995 13.595 5.19995 13.395V2.5446C5.19995 2.3446 5.36291 2.18164 5.56291 2.18164C5.76291 2.18164 5.92588 2.3446 5.92588 2.5446V13.395C5.92588 13.595 5.76291 13.7579 5.56291 13.7579Z",
    fill: "#CFD67B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.70513 15.9407C7.50513 15.9407 7.34216 15.7778 7.34216 15.5778V0.362963C7.34216 0.162963 7.50513 0 7.70513 0C7.90513 0 8.06809 0.162963 8.06809 0.362963V15.5778C8.06809 15.7778 7.90513 15.9407 7.70513 15.9407Z",
    fill: "#CFD67B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.049 11.0998C11.849 11.0998 11.686 10.9369 11.686 10.7369V5.18132C11.686 4.98132 11.849 4.81836 12.049 4.81836C12.249 4.81836 12.412 4.98132 12.412 5.18132V10.7369C12.412 10.9369 12.249 11.0998 12.049 11.0998Z",
    fill: "#CFD67B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.84746 13.7579C9.64746 13.7579 9.4845 13.595 9.4845 13.395V2.5446C9.4845 2.3446 9.64746 2.18164 9.84746 2.18164C10.0475 2.18164 10.2104 2.3446 10.2104 2.5446V13.395C10.2104 13.595 10.0475 13.7579 9.84746 13.7579Z",
    fill: "#CFD67B"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10049_8093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/Music.aeb4a25115fd39d9164366b8d7d57f01.svg";
export { ForwardRef as ReactComponent };